import React, { useContext, useEffect, useState, useCallback } from "react";
import { MdSchool, MdOutlinePlaylistAdd } from "react-icons/md";
import { FaCertificate } from "react-icons/fa"
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import toast from 'react-hot-toast';

import { FirebaseContext } from '../services/Firebase/Context'
import LoadableButton from "../components/LoadableButton";
import { TrainingContext } from "../services/Training";

const ActivityDetailSection = ({ id }: any) => {
  const [loading, setLoading] = useState(false)
  const [record, setRecord] = useState<any>({})
  const { db } = useContext(FirebaseContext) || {}
  const [, setTrainingContext ] = useContext(TrainingContext)

  useEffect(() => {
    if(!id || !db) return
    const unsubscribe = onSnapshot(doc(db, "activities", id), (doc) => {
      setRecord({ id: doc.id, ...doc.data() })
      setTrainingContext({ id: doc.id, name: (doc.data() || {}).name, reference: (doc.data() || {}).reference })
    });
    return () => unsubscribe()
  }, [db, id, setTrainingContext])

  const handleSubmit = useCallback(async e => {
    e.preventDefault()
    if(!db || !id) {
      return
    }
    setLoading(true)
    const { name, reference, goal, expectedResults, desc } = e.target.elements
    if(!name.value || !reference.value || !goal.value) {
      toast.error('Veuillez remplir tous les champs !')
      setLoading(false)
      return
    }
    const record = {
      name: name.value,
      reference: reference.value,
      goal: goal.value,
      expectedResults: expectedResults.value,
      desc: desc.value
    }
    updateDoc(doc(db, "activities", id), record)
    .then(() => {
      toast.success('Formation modifiée avec succès !')
      setLoading(false)
    })
    .catch((e) => {
      setLoading(false)
      toast.error('Erreur veuillez reessayer');
    });
  }, [db, id])

  return (
    <div className="flex flex-col h-full overflow-scroll">
      <div className="shadow-md mt-5">
        <div className="p-4 bg-amber-300 border-t-2 border-amber-400 bg-opacity-5">
          <div className="flex items-center space-x-4">
            <MdSchool className="bg-amber-300 rounded-full h-10 w-10 p-2" color="white" />
            <h1 className="text-gray-600 font-medium uppercase">
              Informations générales
            </h1>
          </div>
        </div>
        <form className="space-y-6 bg-white p-4 text-gray-500" onSubmit={handleSubmit}>
          <div className="flex">
            <div className="flex-1 mr-5">
              <label className="block">
                <span className="text-gray-700 font-medium">
                  Intitulé de l'activité
                  <span className="ml-1 text-red-500 required-dot">*</span>
                </span>
                <input type="text" name="name" defaultValue={record.name} className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    border-gray-300
                    shadow-sm
                    focus:border-purple-300 focus:ring focus:ring-purple-200 focus:ring-opacity-50
                  "/>
              </label>
              <label className="block">
                <span className="text-gray-700 font-medium">
                  Durée (min)
                  <span className="ml-1 text-red-500 required-dot">*</span>
                </span>
                <input type="text" name="reference" defaultValue={record.reference} className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    border-gray-300
                    shadow-sm
                    focus:border-purple-300 focus:ring focus:ring-purple-200 focus:ring-opacity-50
                  "/>
              </label>
              <label className="block">
                <span className="text-gray-700 font-medium">
                  Objectifs de l’activité
                  <span className="ml-1 text-red-500 required-dot">*</span>
                </span>
                <textarea className="
                  mt-1
                  block
                  w-full
                  rounded-md
                  border-gray-300
                  shadow-sm
                  focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                " rows={3} name="goal" defaultValue={record.goal}/>
              </label>
            </div>
            <div className="flex-1 flex flex-col justify-between">
              <label className="block">
                <span className="text-gray-700 font-medium">
                  Tâches du formateur
                </span>
                <textarea className="
                  mt-1
                  block
                  w-full
                  rounded-md
                  border-gray-300
                  shadow-sm
                  focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                " rows={3} name="expectedResults" defaultValue={record.expectedResults} placeholder='Saisir l’objectif opérationnel de l’activité' />
              </label>
              <label className="block">
                <span className="text-gray-700 font-medium">
                  Tâches de l’apprenant
                </span>
                <textarea className="
                  mt-1
                  block
                  w-full
                  rounded-md
                  border-gray-300
                  shadow-sm
                  focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                " rows={3} name="desc" defaultValue={record.desc}/>
              </label>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="w-1/4">
              <LoadableButton title={loading ? 'Enregistrement...' : "Enregistrer"} isSubmit loading={loading} />
            </div>
          </div>
        </form>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 my-6">
        <div className="shadow-md mt-5">
          <div className="p-4 bg-blue-300 border-t-2 border-blue-400 bg-opacity-5">
            <div className="flex items-center space-x-4">
              <MdOutlinePlaylistAdd className="bg-blue-300 rounded-full h-10 w-10 p-2" color="white" />
              <h1 className="text-gray-600 font-medium uppercase">
                Caractéristiques
              </h1>
            </div>
          </div>
          <div className="space-y-6 bg-white p-4 text-gray-500">
            <label className="block">
                <span className="text-gray-700 font-medium">
                  Modalité Collaborative
                </span>
                <select id="countries" className="block">
                  <option>En individuel</option>
                  <option>En groupe</option>
                </select>
              </label>
              <label className="block">
                <span className="text-gray-700 font-medium">
                  Type
                </span>
                <select id="countries" className="block">
                  <option>United States</option>
                  <option>Canada</option>
                  <option>France</option>
                  <option>Germany</option>
                </select>
              </label>
          </div>
        </div>
        <div className="shadow-md mt-5">
          <div className="p-4 bg-lime-300 border-t-2 border-lime-400 bg-opacity-5">
            <div className="flex items-center space-x-4">
              <FaCertificate className="bg-lime-300 rounded-full h-10 w-10 p-2" color="white" />
              <h1 className="text-gray-600 font-medium uppercase">
                Ressources
              </h1>
            </div>
          </div>
          <div className="space-y-6 bg-white p-4 text-gray-500">
            N/A
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActivityDetailSection